import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubSettings}/v4/streaming/`, {
  get: {
    'config.findStreamingCostsBySubdomain': 'costs',
    'config.findBundleStreamingCost': 'cost/bundle',
    'config.findStreamingStatusBySubdomain': 'status',
    'config.findSparkleCampaignStatusBySubdomain': 'status/communication',
    'config.findHotmartPlayerStatus': 'subscription-plan/status',
    'config.findStreamingStatus': ''
  },
  put: {
    'config.updateStreamingAndSparkleCommunicationStatus': 'status',
    'config.updateStreamingStatus': 'status/stream',
    'config.updateSparkleCampaignStatus': 'status/communication',
    'config.updateDrmStatus': 'media-drm-protection/:active'
  }
});

Request.register(`${Settings.api.clubSettings}/v5/membership/`, {
  get: {
    'config.getAllAvailableTemplates': 'customization/templates'
  }
});

Request.register(`${Settings.api.clubSettings}/v4/membership/`, {
  get: {
    'config.findCustomizationDataBySubdomain': 'customization/data',
    'config.getAllPossibleColors': 'customization/colors',
    'config.getMembershipBasicData': 'basic-data',
    'config.getMembershipHelpContent': 'help',
    'config.existsBasicData': 'config/:basicParameter/exists',
    'config.getZendeskConfig': 'zendesk-chat-settings/config'
  },
  put: {
    'config.testDomain': 'domain/test',
    'config.updateCustomizationDataBySubdomain': 'customization/data',
    'config.updateHelpContent': 'help',
    'config.updateMembershipBasicData': 'basic-data',
    'config.updateZendesk': 'zendesk-chat-settings/:token/active/:active'
  },
  delete: {
    'delete.zendeskScript': 'zendesk-chat-settings/'
  }
});

Request.register(`${Settings.api.clubSettings}/v4/certificate/`, {
  get: {
    'config.getCertificateLink': 'public/link',
    'config.getMembershipCertificateSettings': 'settings',
    'config.getDefaultCertificateTemplate': 'template/default'
  },
  put: {
    'config.updateMembershipCertificateSettings': 'settings'
  },
  post: {
    'config.getCertificateLinkPreview': 'preview'
  }
});

Request.register(`${Settings.api.ask}`, {
  get: {
    'ask.verify': '/internal/survey/product/:productId/enabled/'
  },
  patch: {
    'ask.changeAskStatus': '/internal/survey/product/:productId/enabled/:status'
  }
});
